const STRING_MAP = {
  app: 1,
  site: 2,
};

const parse = (value) => {
  if (value === 1 || value === 2) return value;
  if (typeof value === 'number') return value;
  if (typeof value === 'string') {
    const mapped = STRING_MAP[value.toLowerCase()];
    return mapped !== undefined ? mapped : null;
  }
  return null;
};

/** Missing kind is a legacy App. */
const isSite = (value) => parse(value) === 2;

const isApp = (value) => !isSite(value);

export default Object.freeze({
  App: 1,
  Site: 2,
  parse,
  isSite,
  isApp,
});
